/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'closeFullScreen': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g fill-rule="nonzero" _fill="none"><circle pid="0" _fill="#8300BF" cx="12" cy="12" r="12"/><path pid="1" d="M19.75 13.25v1.5h-3.5v3.5h-1.5v-5h5zm-10.5 0v5h-1.5v-3.5h-3.5v-1.5h5zm0-8v5h-5v-1.5l3.5.001V5.25h1.5zm7 0v3.501l3.5-.001v1.5h-5v-5h1.5z" _fill="#FFF"/></g>'
  }
})
